import React from 'react';
import { useNavigate } from 'react-router-dom';
import AssignmentCardComponent from '../../EmployeesRepository/EmployeeForm/components/Assignments/AssignmentCard';

/**
 * MyAssignmentCardItem - Wrapper for AssignmentCardComponent in virtualized grid
 * Handles click events for scroll state capture before navigation
 */
const MyAssignmentCardItem = ({
  assignment,
  employeeId,
  onClick,
  scrollState,
  setLastViewedAssignmentId,
}) => {
  const navigate = useNavigate();

  // Handle card action click - capture scroll state and navigate
  const handleAssignmentAction = () => {
    // Track which assignment is being viewed (for refresh on return)
    if (setLastViewedAssignmentId) {
      setLastViewedAssignmentId(assignment.id);
    }

    // Navigate to the assignment detail page with scroll state
    navigate(`/skills-matrix/assignments/${assignment.id}/${employeeId}`, {
      state: {
        fromList: true,
        scrollState,
        returnPath: '/my-assignments'
      }
    });
  };

  return (
    <AssignmentCardComponent
      assignment={assignment}
      employeeId={employeeId}
      onNavigate={handleAssignmentAction}
    />
  );
};

export default MyAssignmentCardItem;
